import React from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { Button } from '@/components/buttons/Button'

import './Banner.scss'

/**
 * Top-of-app announcement banner used for app-wide notices (e.g. a new version
 * of the app is available, or the customer org has opened a support-access
 * window). Renders above the routed view and respects the nav-sidebar collapse
 * state.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Banner content (message and any inline details).
 * @param {string} [props.actionLabel] - Label for an optional action button.
 * @param {() => void} [props.onAction] - Handler for the optional action button.
 * @param {string} [props.dataTestId] - Override the default `announcement-banner` test id.
 */
export const AnnouncementBanner = ({ children, actionLabel, onAction, dataTestId }) => {
  const { sidebarCollapsed } = useSelector((state) => state.ui)

  return (
    <div
      data-testid={dataTestId || 'announcement-banner'}
      className={classNames('announcement-banner', {
        collapse: sidebarCollapsed,
      })}
    >
      <div>{children}</div>
      {actionLabel && onAction && (
        <div>
          <Button brand type="button" onClick={onAction}>
            {actionLabel}
          </Button>
        </div>
      )}
    </div>
  )
}
